// libs
import styled from 'styled-components'
// views
import { ButtonsWrapper, darkCellCSS, darkTextAreaCSS } from '../../views'

const LeftRowsContainer = styled.div<{ $disabled: boolean }>`
    margin-left: ${({ $disabled }) => ($disabled ? 74 : 20)}px;
    margin-top: 78px;

    ${ButtonsWrapper}:first-child {
        display: flex;
        justify-content: end;
        height: fit-content;
        margin-right: 6px;
    }

    ${ButtonsWrapper}:last-child {
        display: flex;
        justify-content: end;
        margin-top: 6px;
    }
}
`

const LeftRowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const LeftRow = styled.div`
  display: flex;
  gap: 4px;

  > div:last-child {
    ${darkCellCSS};
    ${darkTextAreaCSS};
  }
`

export { LeftRowsContainer, LeftRowsWrapper, LeftRow }
